<template>
  <section class="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
    <Titre textePrincipal="Levée de " texteAccentue="fonds" :isSidebarOpen="isSidebarOpen" />
    <div class="flex flex-row flex-wrap justify-center w-full mx-auto mt-10 rounded-lg shadow-sm px-4">

      <SectionCard v-for="(section, index) in sections" :key="index" :title="section.title" :content="section.content"
        :imageSrc="section.imageSrc" :imageAlt="section.imageAlt" :imageTitle="section.imageTitle"
        :imagePosition="section.imagePosition" :extraContent="section.extraContent">

        <!-- Slot image personnalisé -->
        <template v-if="section.hasCustomImageSlot === 'esthetique'" #image>
          <a href="https://www.facebook.com/p/Esth%C3%A9tique-Aux-Petits-Soins-100054270260390/?locale=fr_FR"
            class="pointer mx-2" target="_blank" rel="noopener noreferrer" title="Clinique esthétique aux petits soins">
            <img :src="imgEsthetique" alt="Clinique esthétique aux petits soins"
              title="Clinique esthétique aux petits soins" />
          </a>
        </template>

        <template v-else-if="section.hasCustomImageSlot === 'porteCles'" #image>
          <a href="https://www.facebook.com/helou35" class="pointer mx-2" target="_blank" rel="noopener noreferrer"
            title="CBO Éducation canine">
            <img :src="imgPorteCles" alt="Porte-clés en biothane" title="Porte-clés en biothane" />
          </a>
        </template>

        <template v-else-if="section.hasCustomImageSlot === 'carrouselPorteCles'" #image>
          <CarouselImages :images="section.images" :alt="section.imageAlt" :title="section.imageTitle" />
        </template>
      </SectionCard>

      <BoutonAdoption></BoutonAdoption>

    </div>

  </section>


</template>

<script setup>
import Titre from '../composants/Titre.vue';
import SectionCard from '../composants/SectionCard.vue';
import { isSidebarOpen } from '../store/storeSideBar';
import BoutonAdoption from '../composants/BoutonAdoption.vue';
import CarouselImages from '../composants/CarousselImages.vue';

import imgAnimaux8 from '../assets/images/animaux_de_la_seconde_chance_8.webp';
import imgContentants from '../assets/images/collecte_de_contenants_consignes.png';
import porteClesRLeatherWorks from '../assets/images/partenaires/porte_cles_cuir__chat.webp';
import porteClesRLeatherWorks2 from '../assets/images/partenaires/porte_cles_cuir__chat_2.webp';
import imgAnimaux9 from '../assets/images/animaux_de_la_seconde_chance_9.webp';
import imgEsthetique from '../assets/images/partenaires/partenaire_esthetique_aux_petits_soins.png';
import imgPorteCles from '../assets/images/partenaires/porte_cles_chats.webp';


const sections = [
  {
    title: 'Collecte de contenants :',
    content: [
      `Chaque année, nous organisons plusieurs collectes de contenants consignés pour soutenir les frais liés au sauvetage de dizaines de chats. Votre participation à ces levées de fonds est précieuse, car chaque don collecte contribue à sauver une ou plusieurs vies. Si vous souhaitez nous aider, nous avons un point de dépôt situé au 196, rue Courtemanche à Matane.`,
    ],
    imageSrc: imgAnimaux8,
    imageAlt: 'Chat',
    imageTitle: 'Animaux de la seconde chance',
    imagePosition: 'right',
  },
  {
    title: 'Prochaine collecte de contenants consignés :',
    content: [
      `Date à déterminer`,
      `Il vous suffit de nous communiquer votre adresse par courriel, et nous nous ferons un plaisir de venir chercher vos contenants consignés. Nous acceptons également les dons de nourriture, de litière, et tout autre matériel qui pourrait améliorer le bien-être de nos adorables compagnons à quatre pattes. Matane.`,
    ],
    imageSrc: imgContentants,
    imageAlt: 'Contenants consignés',
    imageTitle: 'Contenants consignés',
    imagePosition: 'left',
  },
  {
    title: "Vente de porte-clés en cuir fait à la main:",
    content: [
      `Nous sommes très heureux de vous annoncer que tous nos porte-clés en cuir faits main, délicatement conçus en forme de chats, ont trouvé preneurs ! Grâce à la générosité et au soutien précieux de Rock Leather Works, nous avons pu récolter 105&nbsp;$ pour notre organisme, grâce à la vente de 21 porte-clés à 5&nbsp;$ chacun.`,
    ],
    images: [porteClesRLeatherWorks, porteClesRLeatherWorks2],
    imageAlt: 'Porte-clés en cuir fait à la main',
    imageTitle: 'Porte-clés en cuir fait à la main',
    imagePosition: 'right',
    extraContent:
      `Un immense merci à chacun d’entre vous qui avez choisi ces magnifiques porte-clés et à <a href="http://www.rockleatherworks.com/" target="_blank" rel="noopener noreferrer" title="Rock Leather Works" class="text-navigation hover:underline font-bold">Rock&nbsp;Leather&nbsp;Works</a> pour son engagement à nos côtés. Votre soutien fait toute la différence !`,
    hasCustomImageSlot: 'carrouselPorteCles',
  },
  {
    title: "Tirage d'une belle frileuse faite à la main :",
    content: [
      `Nous avons le plaisir d’annoncer que la gagnante de la belle frileuse est Madame Pauline Truchon. Un immense merci à toutes et à tous ceux qui ont participé, ainsi qu’à la généreuse personne qui a fait don de cette frileuse.`,
    ],
    imageSrc: imgAnimaux9,
    imageAlt: 'Chat avec une frileuse',
    imageTitle: 'Chat avec une frileuse',
    imagePosition: 'left',
  },
  {
    title: 'Levée de fond spéciale :',
    content: [
      `Nous sommes ravis de vous présenter une initiative généreuse de Madame Hélène Ross pour recueillir des fonds pour notre organisme. Elle propose de magnifiques porte-clés en biothane au prix de 15&nbsp;$ chacun. Pour chaque porte-clé vendu, 2&nbsp;$ seront reversés aux Animaux de la Seconde Chance de la région de Matane.`,
    ],
    imageSrc: imgPorteCles,
    imageAlt: 'Porte-clés en biothane',
    imageTitle: 'Porte-clés en biothane',
    imagePosition: 'right',
    extraContent:
      "Pour acheter dès maintenant votre <b>porte-clé</b>, contactez Hélène Ross via sa page <a href='https://www.facebook.com/helou35' class='text-navigation hover:underline font-bold'>Facebook</a>.<br>Votre soutien fait toute la différence pour nos animaux. Merci de contribuer à leur bien-être et à leur avenir !",
    hasCustomImageSlot: 'porteCles',
  },
  {
    title: "Tirage d'un certificat cadeau :",
    content: [
      `Nous sommes ravis d'annoncer que Madame Patsy Fournier a remporté le certificat cadeau d'une valeur de 100&nbsp;$ de la Clinique d'Esthétique aux Petits Soins. Un grand merci à tous ceux qui ont acheté des billets pour soutenir notre cause.`,
    ],
    imageSrc: imgEsthetique,
    imageAlt: 'Clinique esthétique aux petits soins',
    imageTitle: 'Clinique esthétique aux petits soins',
    imagePosition: 'left',
    extraContent:
    "Nous tenons également à exprimer notre profonde gratitude à Annie Tremblay pour son don généreux. Sa clinique est située au 165 rue Soucy à Matane, et vous pouvez la contacter au (418)&nbsp;562-3004 pour toute question concernant les services offerts.<br>Merci infiniment pour votre soutien !",
    hasCustomImageSlot: 'esthetique',

  },
  
];


</script>
<style scoped>
section {
  overflow-x: hidden;
}

img {
  max-width: 100%;
  height: auto;
  object-fit: cover;
}
</style>